import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {TextTranslatedSearchParams} from '../../text-translated-search-params';
import {TextTranslated} from '../../text-translated';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-text-translated-list',
  templateUrl: './text-translated-list.component.html',
  styleUrls: []
})
export class TextTranslatedListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new TextTranslatedSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/text-translated', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: TextTranslated) {
    this.router.navigateByUrl(`/text-translated/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/text-translated/create']);
  }
}
